document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.getElementById('navToggle');
  const menu   = document.getElementById('navMenu');
  if (!toggle || !menu) return;

  const closeMenu = () => {
    toggle.setAttribute('aria-expanded', 'false');
    toggle.classList.remove('is-open');
    menu.classList.remove('show');
  };

  toggle.addEventListener('click', () => {
    const open = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!open));
    toggle.classList.toggle('is-open', !open);
    menu.classList.toggle('show', !open);
  });

  // Cerrar con ESC y al tocar fuera (opcional pero útil)
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeMenu();
  });
  document.addEventListener('click', (e) => {
    if (!menu.contains(e.target) && !toggle.contains(e.target)) closeMenu();
  });

  // Cerrar al hacer click en un link del menú
  menu.querySelectorAll('a').forEach(a => {
    a.addEventListener('click', closeMenu);
  });
});

// Reveal texto hero en load (stagger con data-d)
document.addEventListener('DOMContentLoaded', () => {
  const toReveal = document.querySelectorAll('.reveal-left, .reveal-right');
  // setear delays desde data-d si existen
  toReveal.forEach(el => {
    if (el.dataset.d) el.style.setProperty('--d', el.dataset.d);
  });
  // forzar en el siguiente frame para que la transición ocurra
  requestAnimationFrame(() => {
    toReveal.forEach(el => el.classList.add('is-visible'));
  });
});

document.addEventListener('DOMContentLoaded', function () {
  var faqToggles = document.querySelectorAll('.ebooks-faq__toggle');

  if (!faqToggles.length) return;

  faqToggles.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.ebooks-faq__item');
      var isOpen = item.classList.contains('is-open');

      // Opcional: cerrar los demás para efecto acordeón
      document.querySelectorAll('.ebooks-faq__item.is-open').forEach(function (openItem) {
        if (openItem !== item) {
          openItem.classList.remove('is-open');
        }
      });

      // Toggle del item actual
      item.classList.toggle('is-open', !isOpen);
    });
  });
});